export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";